// Import utilities
import { useAgreementsStatus, useFetchAgreements } from 'components/utilities';

/**
 * Custom hook that handles accepting agreements
 *
 * fetchSubscriberAgreements (bool) -> using for fetching all subscriber agreements
 * subscriberAgreementsToFetch (arrayOf(string)) -> using for fetching subscriber agreement by TYPE
 *
 * removeInitialAccepted (bool) -> using for removing already accepted agreements
 * initialAcceptedToRemove (arrayOf(string)) -> using for removing already accepted agreements by TYPE
 */
const useAgreements = ({
	queryKey,
	agreementsToFetch,
	useCache,
	initialAcceptedAgreements,
	fetchSubscriberAgreements,
	subscriberAgreementsToFetch,
	removeInitialAccepted,
	initialAcceptedToRemove,
	initialAcceptDefaultAgreements,
	isEnabled
}) => {
	const {
		agreements,
		isAgreementsError,
		isAgreementsLoading,
		isAgreementsFetching,
		acceptSubscriberAgreements,
		declineSubscriberAgreements
	} = useFetchAgreements({
		queryKey,
		agreementsToFetch,
		useCache,
		fetchSubscriberAgreements,
		subscriberAgreementsToFetch,
		removeInitialAccepted,
		initialAcceptedToRemove,
		isEnabled
	});

	const {
		isAllAgreementsAccepted,
		isObligatoryAgreementsAccepted,
		acceptedAgreementsVersionIds,
		acceptedAgreements,
		toggleAgreement,
		toggleAllAgreements,
		setAcceptedAgreementsVersionIds,
		isCustomAgreementAccepted,
		setIsCustomAgreementAccepted
	} = useAgreementsStatus({
		agreements,
		initialAcceptedAgreements,
		initialAcceptDefaultAgreements
	});

	return {
		agreements,
		isAgreementsError,
		isAgreementsLoading,
		isAgreementsFetching,
		acceptSubscriberAgreements,
		declineSubscriberAgreements,
		isAllAgreementsAccepted,
		isObligatoryAgreementsAccepted,
		acceptedAgreementsVersionIds,
		acceptedAgreements,
		toggleAgreement,
		toggleAllAgreements,
		setAcceptedAgreementsVersionIds,
		isCustomAgreementAccepted,
		setIsCustomAgreementAccepted
	};
};

export default useAgreements;
